module.exports = __webpack_public_path__ + "static/img/tip_info_img_tw.d5a72e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/tip_info_img_tw.jpg
// module id = wWRG
// module chunks = 52